import React from "react";
import { Box } from "@mui/material";
import AddressSelector from "./AddressSelector";
import TimeSelector from "./TimeSelector";
import { C, RADIUS } from "../../utils/designTokens";

/**
 * "Salem, MA · Now" — where and when, in one pill. Each half is its own button
 * and opens the same address / time pickers the header always had.
 * compact (phones): the time half drops its icons to leave room for the place.
 */
function LocationTimePill({ maxLabelWidth = 160, compact = false }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        height: 44,
        px: "3px",
        minWidth: 0,
        flexShrink: 1,
        borderRadius: RADIUS.pill,
        border: `1px solid ${C.borderStrong}`,
        bgcolor: C.bg,
      }}
    >
      <AddressSelector variant="pill" maxLabelWidth={maxLabelWidth} />
      <Box component="span" aria-hidden="true" sx={{ color: C.muted, fontWeight: 700, px: "1px" }}>
        ·
      </Box>
      <TimeSelector variant="pill" compact={compact} />
    </Box>
  );
}

export default React.memo(LocationTimePill);
